// Car brand logo SVG icons as React components
export const BrandLogos = {
  renault: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2L5.5 21h3.2l1.5-4.5h3.6L15.3 21h3.2L12 2zm0 5.5l2.1 6.5H9.9L12 7.5z"/>
    </svg>
  ),
  ford: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <ellipse cx="12" cy="12" rx="11" ry="7" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <text x="12" y="15" textAnchor="middle" fontSize="9" fontFamily="serif" fontStyle="italic" fill="currentColor">Ford</text>
    </svg>
  ),
  mercedes: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <line x1="12" y1="2" x2="12" y2="8.5" stroke="currentColor" strokeWidth="1.2"/>
      <line x1="12" y1="15.5" x2="4" y2="19" stroke="currentColor" strokeWidth="1.2"/>
      <line x1="12" y1="15.5" x2="20" y2="19" stroke="currentColor" strokeWidth="1.2"/>
    </svg>
  ),
  bmw: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <line x1="12" y1="2" x2="12" y2="22" stroke="currentColor" strokeWidth="1"/>
      <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="1"/>
      <path d="M12 2a10 10 0 010 10" fill="currentColor" opacity="0.3"/>
      <path d="M12 12a10 10 0 010 10" fill="currentColor" opacity="0.3"/>
    </svg>
  ),
  volkswagen: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6 7l6 10 6-10" fill="none" stroke="currentColor" strokeWidth="1.3"/>
      <path d="M8 17l4-7 4 7" fill="none" stroke="currentColor" strokeWidth="1.3"/>
    </svg>
  ),
  opel: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3 12 Q12 6 21 12" fill="none" stroke="currentColor" strokeWidth="1.3"/>
    </svg>
  ),
  daf: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <rect x="3" y="7" width="18" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <text x="12" y="15" textAnchor="middle" fontSize="7" fontWeight="bold" fill="currentColor">DAF</text>
    </svg>
  ),
  man: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <rect x="2" y="6" width="20" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <text x="12" y="15" textAnchor="middle" fontSize="7" fontWeight="bold" fill="currentColor">MAN</text>
    </svg>
  ),
  default: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...props}>
      <path d="M5 17h14M5 17a2 2 0 01-2-2V9a2 2 0 012-2h1l2-3h8l2 3h1a2 2 0 012 2v6a2 2 0 01-2 2M7 17v2m10-2v2"/>
      <circle cx="7.5" cy="14.5" r="1.5"/><circle cx="16.5" cy="14.5" r="1.5"/>
    </svg>
  ),
};

export function getBrandLogoComponent(brand) {
  if (!brand) return BrandLogos.default;
  const key = brand.toLowerCase().trim();
  if (key === 'vw') return BrandLogos.volkswagen;
  return BrandLogos[key] || BrandLogos.default;
}
